export default __webpack_public_path__ + "static/media/loading-background.985ecad1.png";